import React from 'react';
import { Box, Skeleton } from '@mui/material';

const HeaderCardSkeleton = () => {
  // Create 4 skeleton cards to match the ORDER_STATS array length
  const skeletonCards = Array.from({ length: 5 }, (_, index) => (
    <Box key={index} className="headerCard">
      <Box className="headerCardContent">
        {/* Icon skeleton */}
        <Skeleton 
          variant="rectangular" 
          width={64} 
          height={64} 
          sx={{ borderRadius: '8px' }}
        />
        
        {/* Content skeleton */}
        <Box className="headerCardDetails">
          {/* Label skeleton */}
          <Skeleton 
            variant="text" 
            width="60%" 
            height={20}
            sx={{ marginBottom: '8px' }}
          />
          
          {/* Value skeleton */}
          <Skeleton 
            variant="text" 
            width="80%" 
            height={24}
          />
        </Box>
      </Box>
    </Box>
  ));

  return (
    <Box className="headerCardContainer">
      {skeletonCards}
    </Box>
  );
};

export default HeaderCardSkeleton; 